import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';
import CdnImage from '@prisjakt/ui-cdn-image';

import './shop-card.scss';

const styles = bemGenerator('pj-ui-shop-card', [
  'button',
  'logo',
  'call-to-action',
]);

const ShopCard = ({
  id,
  name,
  width,
  height,
  logo,
  hasLogo,
  featured,
  onClick,
  callToActionText,
}) => (
  <div className={styles.block}>
    <button
      type="button"
      className={styles.button}
      onClick={onClick}
      style={{ width, height }}
    >
      {hasLogo && id ? (
        <CdnImage type="store" name={id} width={width} />
      ) : (
        <span className={styles.logo}>
          {logo && featured ? <img alt={name} src={logo} /> : name}
        </span>
      )}
      {callToActionText && (
        <span className={styles['call-to-action']}>{callToActionText}</span>
      )}
    </button>
  </div>
);

const { bool, number, string, func } = PropTypes;

ShopCard.propTypes = {
  id: number,
  name: string.isRequired,
  width: number,
  height: number,
  logo: string,
  hasLogo: bool,
  featured: bool,
  onClick: func,
  callToActionText: string,
};

ShopCard.defaultProps = {
  id: undefined,
  width: undefined,
  height: undefined,
  logo: undefined,
  hasLogo: false,
  featured: false,
  onClick: () => {},
  callToActionText: undefined,
};

export default ShopCard;
